import type { MilestonesContent } from "../types";
import { renderSectionHeader } from "./section-header";

/** 里程碑：垂直时间线，节点复用品牌地平线的菱形元素 */
export function renderMilestones(ms: MilestonesContent): string {
  const items = ms.items
    .map(
      (m, i) => `
      <div class="milestone" data-reveal style="--i:${i}">
        <span class="ms-node" aria-hidden="true"></span>
        <span class="ms-year">${m.year}</span>
        <div class="ms-body">
          <h3>${m.title}</h3>
          <p>${m.description}</p>
        </div>
      </div>`,
    )
    .join("");

  return `
    <section class="section" id="${ms.id}">
      ${renderSectionHeader(ms.header)}
      <div class="milestones">${items}</div>
    </section>`;
}
